module.exports = __webpack_public_path__ + "prod/1.42.2/img/consumption-chain.d292bd2f.png";